import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c582a48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "amap-location-select" }
const _hoisted_2 = { class: "search-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "info-footer"
}
const _hoisted_4 = { class: "address-text" }
const _hoisted_5 = { class: "coords-text" }

import { ref, reactive, onMounted, onUnmounted, watch, nextTick } from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";
import { EnvironmentOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";

interface LocationInfo {
  lng: number;
  lat: number;
  address: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  value: {
    type: Object as () => { lng: number; lat: number } | null,
    default: null,
  },
  address: {
    type: String,
    default: "",
  },
  height: {
    type: String,
    default: "400px",
  },
  zoom: {
    type: Number,
    default: 13,
  },
  amapKey: {
    type: String,
    default: "ab312b9438fe581216cdec4aa1cd8da1", // 默认测试Key，实际使用时请替换为申请的Key
  },
  securityCode: {
    type: String,
    default: "",
  },
},
  emits: ["update:value", "update:address", "change"],
  setup(__props, { emit }) {

const props = __props

_useCssVars(_ctx => ({
  "1adac041": (props.height)
}))





const mapRef = ref<HTMLElement | null>(null);
const searchKeyword = ref("");
const searchLoading = ref(false);
const locationInfo = reactive<LocationInfo>({
  lng: 0,
  lat: 0,
  address: "",
});

let map: any = null;
let marker: any = null;
let geocoder: any = null;
let AMapInstance: any = null;

// 初始化地图
const initMap = async () => {
   // 配置安全密钥,自2021年12月02日升级，升级之后所申请的 key 必须配备安全密钥 jscode 一起使用
    (window as any)._AMapSecurityConfig = {
      securityJsCode: '2aa1448afd099bad6b11c2c88c3abd82',
    };

  try {
    AMapInstance = await AMapLoader.load({
      key: 'ab312b9438fe581216cdec4aa1cd8da1',
      version: "2.0",
      plugins: ["AMap.Geocoder", "AMap.AutoComplete", "AMap.PlaceSearch"],
    });

    const initialCenter =
      props.value?.lng && props.value?.lat
        ? [props.value.lng, props.value.lat]
        : [116.397428, 39.90923];

    map = new AMapInstance.Map(mapRef.value, {
      zoom: props.zoom,
      center: initialCenter,
    });

    geocoder = new AMapInstance.Geocoder({
      city: "全国",
    });

    marker = new AMapInstance.Marker({
      position: initialCenter,
      map: map,
      draggable: true,
    });

    // 初始位置解析
    if (props.value?.lng && props.value?.lat) {
      locationInfo.lng = props.value.lng;
      locationInfo.lat = props.value.lat;
      locationInfo.address = props.address;
    }

    // 地图点击事件
    map.on("click", (e: any) => {
      const { lng, lat } = e.lnglat;
      setLocation(lng, lat);
    });

    // 标记拖拽结束事件
    marker.on("dragend", (e: any) => {
      const { lng, lat } = e.lnglat;
      setLocation(lng, lat);
    });
  } catch (error) {
    console.error("AMap initialization failed:", error);
    message.error("地图加载失败，请检查网络或配置");
  }
};

// 设置位置并进行逆地理编码
const setLocation = (lng: number, lat: number, shouldEmit = true) => {
  locationInfo.lng = lng;
  locationInfo.lat = lat;

  const position = new AMapInstance.LngLat(lng, lat);
  marker.setPosition(position);
  map.setCenter(position);

  geocoder.getAddress(position, (status: string, result: any) => {
    if (status === "complete" && result.regeocode) {
      const address = result.regeocode.formattedAddress;
      locationInfo.address = address;

      if (shouldEmit) {
        emit("update:value", { lng, lat });
        emit("update:address", address);
        emit("change", { lng, lat, address });
      }
    } else {
      message.warning("未能解析该位置的详细地址");
    }
  });
};

// 搜索处理
const handleSearch = (value: string) => {
  if (!value) return;
  searchLoading.value = true;

  const placeSearch = new AMapInstance.PlaceSearch({
    city: "全国",
    map: map,
  });

  placeSearch.search(value, (status: string, result: any) => {
    searchLoading.value = false;
    if (status === "complete" && result.poiList && result.poiList.pois.length > 0) {
      const firstPoi = result.poiList.pois[0];
      const { lng, lat } = firstPoi.location;
      setLocation(lng, lat);
    } else {
      message.info("未搜索到相关位置");
    }
  });
};

// 监听外部值变化
watch(
  () => props.value,
  (newVal) => {
    if (newVal && newVal.lng && newVal.lat && map) {
      if (newVal.lng !== locationInfo.lng || newVal.lat !== locationInfo.lat) {
        setLocation(newVal.lng, newVal.lat, false);
      }
    }
  },
  { deep: true }
);

onMounted(() => {
  nextTick(() => {
    initMap();
  });
});

onUnmounted(() => {
  if (map) {
    map.destroy();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_input_search, {
        value: searchKeyword.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
        placeholder: "请输入地点进行搜索",
        "enter-button": "",
        onSearch: handleSearch,
        loading: searchLoading.value,
        "allow-clear": ""
      }, null, 8, ["value", "loading"])
    ]),
    _createElementVNode("div", {
      ref_key: "mapRef",
      ref: mapRef,
      class: "map-container"
    }, null, 512),
    (locationInfo.address)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(EnvironmentOutlined)),
            _createElementVNode("span", null, _toDisplayString(locationInfo.address), 1)
          ]),
          _createElementVNode("div", _hoisted_5, " 经度: " + _toDisplayString(locationInfo.lng.toFixed(6)) + " | 纬度: " + _toDisplayString(locationInfo.lat.toFixed(6)), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})